<template>
  <div class="" v-if="status != 'null'">
    <p
      class="w-8 h-8 flex opacity-li5 items-center justify-center main font-semibold rounded-full border-dark text-dark"
      :title="status"
    >
      {{ status.charAt(0) }}
      {{ [...status.substring(status.indexOf(" ") + 1)][0] }}
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      initial: "",
    };
  },
  watch: {
    status() {},
  },
  //       watch:{
  //       status(){
  //         alert(status)
  //  let fullname=this.status;

  //  let namearr=fullname.split(" ");

  //  let fiestinitial=namearr[0].charAt[0]
  //  if(namearr.length>1){
  // var lastinitial=namearr[namearr.length-1].charAt(0)||" "
  // this.initial=fiestinitial+lastinitial

  // console.log(this.initial,"iiiiiiiiiiiiiiiiiiii")
  //  }
  //       }
  //     },
  props: {
    status: String,
  },
};
</script>
<style>
.main {
  font-size: 9px;
}
.opacity-li5 {
  opacity: 0.7;
}
</style>
